var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcSortInactive({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.70312 5.83333C2.70312 5.3731 3.07622 5 3.53646 5H10.2031C10.6634 5 11.0365 5.3731 11.0365 5.83333C11.0365 6.29357 10.6634 6.66667 10.2031 6.66667H3.53646C3.07622 6.66667 2.70312 6.29357 2.70312 5.83333Z",
    fill: "#97A2B6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.70312 10C2.70312 9.53976 3.07622 9.16667 3.53646 9.16667H8.53646C8.9967 9.16667 9.36979 9.53976 9.36979 10C9.36979 10.4602 8.9967 10.8333 8.53646 10.8333H3.53646C3.07622 10.8333 2.70312 10.4602 2.70312 10Z",
    fill: "#97A2B6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.70312 14.1667C2.70312 13.7064 3.07622 13.3333 3.53646 13.3333H6.86979C7.33003 13.3333 7.70312 13.7064 7.70312 14.1667C7.70312 14.6269 7.33003 15 6.86979 15H3.53646C3.07622 15 2.70312 14.6269 2.70312 14.1667Z",
    fill: "#97A2B6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.7031 11.6667C17.7031 11.6667 17.7031 11.6667 17.7031 11.6667C18.0286 11.9921 18.0286 12.5197 17.7031 12.8452C17.7031 12.8452 17.7031 12.8452 17.7031 12.8452L16.3816 14.1667C15.8261 14.7222 15.5483 15 15.2031 15C14.8579 15 14.5802 14.7222 14.0246 14.1667L12.7031 12.8452C12.3777 12.5197 12.3777 11.9921 12.7031 11.6667C13.0286 11.3412 13.5562 11.3412 13.8816 11.6667C13.8816 11.6667 13.8816 11.6667 13.8816 11.6667L14.3698 12.1548V5L16.0365 5V12.1548L16.5246 11.6667V11.6667C16.8501 11.3412 17.3777 11.3412 17.7031 11.6667C17.7031 11.6667 17.7031 11.6667 17.7031 11.6667Z",
    fill: "#97A2B6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSortInactive);
export default __webpack_public_path__ + "static/media/ic-sort-inactive.0785012b2bb85570397a09f578409028.svg";
export { ForwardRef as ReactComponent };